import { DESKTOP_SMALL } from '@constants/screenBreakpoints';

export const isSmallWindowWidth = (checkWidth = DESKTOP_SMALL): boolean =>
  window.innerWidth <= checkWidth;

export const countLimitByWindowHeight = (itemHeight: number, verticalPaddings = 0): number =>
  Math.floor((window.innerHeight - verticalPaddings) / itemHeight);
